import React from 'react'
import PropTypes from 'prop-types'
import styles from '../styles/components/Section.module.css'

const Section = (props) => {
    return (
        <div className={styles.section}>

            <div className={styles.container}>

                <div className={props.imageOnRight ? styles.imageContainer1 : styles.imageContainer2}>
                    <img src={props.image} alt={props.alt} />
                </div>

                <div className={props.imageOnRight ? styles.textContainer1 : styles.textContainer2}>

                    <h1 className={styles.title}>
                        {props.title}
                    </h1>

                    <p className={styles.description}>
                        {props.description}
                    </p>

                </div>
            </div>

            <div className={props.hasExtraContent ? styles.contentContainer : styles.contentContainerHidden}>
                <p className={styles.content}>
                    {props.extraContent}
                </p>
            </div>

            <div className={styles.button}>
                {props.children}
            </div>

        </div>
    )
}

Section.defaultProps = {
    imageOnRight: true,
    image: '../assets/images/hero_circle_small',
    alt: 'Image',
    title: 'Title',
    description: 'Description',
    extraContent: 'This is the extra content area',
    hasExtraContent: false,
}

Section.propTypes = {
    imageOnRight: PropTypes.bool,
    image: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    extraContent: PropTypes.string,
    hasExtraContent: PropTypes.bool,
}

export default Section
